import React, { useCallback, useState } from "react";
import { Input, Label } from "reactstrap";
import cx from "classnames";
import { TranslateWrapper } from "components/TranslateWrapper";
import type { TranslateWrapperProps } from "interfaces/shared.types";
import { Icon } from "../Icon/Icon";
import styles from "./Inputs.module.scss";

type PasswordInputProps = {
  value: string;
  label: string | { props: TranslateWrapperProps };
  error?: Error | null;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  id: string;
  testId: string;
  classNames?: string;
};

export const PasswordInput = ({
  value,
  label,
  error,
  onChange,
  name,
  id,
  testId,
  classNames = "mb-3",
}: PasswordInputProps) => {
  const [isFocused, setIsFocused] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const placeholderText = typeof label === "string" ? label : label.props.text;

  const toggleIsFocused = useCallback(() => {
    setIsFocused((val) => !val);
  }, []);

  const togglePasswordShow = useCallback(() => {
    setShowPassword((prev) => !prev);
  }, []);

  return (
    <div className={cx(styles.wrapper, classNames)}>
      {(value || isFocused) && (
        <Label for={name} className={styles.label}>
          {typeof label === "string" ? (
            label
          ) : (
            <TranslateWrapper {...label.props} />
          )}
        </Label>
      )}
      <Input
        type={showPassword ? "text" : "password"}
        required
        placeholder={!isFocused ? placeholderText : ""}
        className={cx(styles.textInput, { "border-danger": error })}
        name={name}
        id={id}
        data-testid={testId}
        onChange={onChange}
        value={value}
        onFocus={toggleIsFocused}
        onBlur={toggleIsFocused}
      />
      {value && (
        <Icon
          className={cx(styles.icon, "cursor-pointer icon-16")}
          iconName={showPassword ? "eye-slash-regular" : "eye-regular"}
          data-testid={`eye-icon-${testId}`}
          onClick={togglePasswordShow}
        />
      )}
      {typeof label === "object" && (
        <TranslateWrapper
          tooltipText={label.props.tooltipText}
          tooltipId={id}
        />
      )}
    </div>
  );
};
